// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container{
  position:fixed;
  right:1rem;
  bottom:1rem;
  z-index:102;
  display:flex;
  flex-direction:column;
  row-gap:0.5rem;
  width:calc(100% - 1.5rem);
  max-width:25.75rem;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
